import { FC } from 'react';
import { MaterialSymbol } from 'vopay';

type LinkButtonProps = {
  link: string;
};

const LinkButton: FC<LinkButtonProps> = ({ link }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <MaterialSymbol icon="open_in_new" size="24px" color="hsla(216, 100%, 59%, 1)" />
    </a>
  );
};

export default LinkButton;
